frappe.provide('ftcore');

/**
 * Moves a portal's status pill in place once an answer has been recorded, so a supplier who
 * declines/approves sees it reflected without reloading.
 *
 * This reflects a write; it does not make one — the status is already saved server-side, and the
 * endpoint hands back what it stored so the caller can pass it in here.
 *
 * Loaded on web portals via `ct_website.bundle.js`; the pill is rendered by
 * `templates/portal/portal_macros.html` → `status_badge`, carrying the `js-ftp-status` hook.
 */

// Tone classes `status_badge` can carry, so an update can remove the old one without knowing which
// it was.
const BADGE_TONES = ["ok", "danger", "warn", "info", "neutral"];

/**
 * Update the portal's status pill.
 *
 * @param {string} status - The status to show, as the SERVER recorded it. Rendered as given.
 * @param {object} [tones] - `{status: tone}`, from `page_context.status_tones`. Falls back to
 *      `neutral` for a status the map doesn't name.
 * @returns {boolean} Whether a pill was found and updated.
 */
ftcore.set_portal_status = function (status, tones) {
    const $badge = $(".js-ftp-status").first();
    if (!$badge.length || !status) return false;

    const tone = (tones || {})[status] || "neutral";

    BADGE_TONES.forEach(name => $badge.removeClass("ftp-badge--" + name));
    $badge.addClass("ftp-badge--" + tone);

    // `.text()`, never `.html()`: this value crosses from a JSON response into the DOM.
    $badge.text(status);
    return true;
};
